// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import ChoiceWithOptionController from "./choice_with_option_controller"
application.register("choice-with-option", ChoiceWithOptionController)

import ChoiceWithRelatedFieldsController from "./choice_with_related_fields_controller"
application.register("choice-with-related-fields", ChoiceWithRelatedFieldsController)

import DeviceDetectionController from "./device_detection_controller"
application.register("device-detection", DeviceDetectionController)

import DownloadController from "./download_controller"
application.register("download", DownloadController)

import FormControlDisablingController from "./form_control_disabling_controller"
application.register("form-control-disabling", FormControlDisablingController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import KeyboardFocusController from "./keyboard_focus_controller"
application.register("keyboard-focus", KeyboardFocusController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ScrollingController from "./scrolling_controller"
application.register("scrolling", ScrollingController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TransitionController from "./transition_controller"
application.register("transition", TransitionController)
